export default __webpack_public_path__ + "static/media/ExpressCharge.c6af36c7.svg";